import { Reducer } from "redux";

import { TrainingVideoResponse } from "../models/api/Training";
import { TrainingVideoDispatchTypes } from "../models/dispatchTypes/Training";
import { GetTrainingVideoActionDispatchTypes } from "../constants/Training";

const initialState: TrainingVideoResponse = {
  loading: false,
  response: [],
  error: null,
};

const TrainingVideoReducer: Reducer<
  TrainingVideoResponse,
  TrainingVideoDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetTrainingVideoActionDispatchTypes.GET_TRAINING_VIDEO_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetTrainingVideoActionDispatchTypes.GET_TRAINING_VIDEO_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetTrainingVideoActionDispatchTypes.GET_TRAINING_VIDEO_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetTrainingVideoActionDispatchTypes.GET_TRAINING_VIDEO_RESET: {
      return initialState;
    }
  }
  return state;
};

export default TrainingVideoReducer;
